import { LinearProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { formService } from "../../_services/form.service";

export function UserCompetitionLicenseApplication() {

    const { userId, formId } = useParams<{ userId: string, formId: string }>();

    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchData(userId || accountService.currentUserValue.id);
    }, [formId]);

    function fetchData(id: string) {
        setIsLoading(true)
        return formService
            .getByType(FormTemplateTypeEnum.CompetitionLicenceApplication, userId)
            .then(
                (json) => {
                    if (json) {
                        navigate("../Forms/"+json);
                    }
                    else{
                        navigate("Create");
                    }
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            {isLoading && <LinearProgress color="secondary" />}

            <Outlet></Outlet>
        </>
    );

}
